export default __webpack_public_path__ + "static/media/fundoLogin.c74274c9.png";